/* oxlint-disable */
// Этот файл сгенерирован @cian/swagger-generator
// не вносите в него ручные изменения, иначе они будут утеряны
import type {  ICianApiSiteV1GetLocationRequest,  TCianApiSiteV1GetLocationModel,  IMappers,  TCianApiSiteV1GetLocationResponse } from './types'
import type {  IHttpApi,  IHttpApiFetchConfig,  FetchResponse } from '@cian/http-api'
import type {  IGetLocationResponseSchema49 } from '../../../../entities/schemas/GetLocationResponseSchema49'
import type {  IErrorResponseSchema50 } from '../../../../entities/schemas/ErrorResponseSchema50'


export function createCianApiSiteV1GetLocationModel(parameters: ICianApiSiteV1GetLocationRequest): TCianApiSiteV1GetLocationModel {
return {
v: 1,apiType: 'legacy',method: 'GET',microserviceName: 'monolith-python',pathApi: '/cian-api/site/v1/get-location/',response: {
200: {
contentType: 'json',
},400: {
contentType: 'json',
},
},request: {
parameters,

},
};
}


export interface ICianApiSiteV1GetLocationOptions<TResponse200, TResponse400>  {
httpApi: IHttpApi;
config?: IHttpApiFetchConfig;
mappers?: IMappers<TResponse200, TResponse400>;
parameters: ICianApiSiteV1GetLocationRequest;

}

export async function fetchCianApiSiteV1GetLocation<TResponse200, TResponse400>({
httpApi,
config,
mappers,
parameters,

}: ICianApiSiteV1GetLocationOptions<TResponse200, TResponse400>): Promise<FetchResponse<TCianApiSiteV1GetLocationResponse> | TResponse200 | TResponse400> {
const {
statusCode,
response,
headers,

} = (await httpApi.fetch(createCianApiSiteV1GetLocationModel(parameters), config)) as FetchResponse<TCianApiSiteV1GetLocationResponse>;
if (mappers && statusCode in mappers) {
if (statusCode === 200) {
return mappers[200](response as IGetLocationResponseSchema49, headers);
}if (statusCode === 400) {
return mappers[400](response as IErrorResponseSchema50, headers);
}
}return {
statusCode,
response,
headers,

} as FetchResponse<TCianApiSiteV1GetLocationResponse>;
}

